(function () {
  'use strict';

  var PRICING = Object.freeze({ baseTotal: 79, deposit: 20, weddingTotal: 300, weddingDeposit: 50, rushFee: 20 });
  var FORMS_HOST_SELECTOR = 'shopify-forms-embed';
  var MAX_FORM_RETRIES = 40;
  var FORM_RETRY_DELAY = 200;

  function calculateCustomQuote(rush, wedding) {
    var total = wedding ? PRICING.weddingTotal : PRICING.baseTotal + (rush ? PRICING.rushFee : 0);
    var deposit = wedding ? PRICING.weddingDeposit : PRICING.deposit;
    return { total: total, deposit: deposit, balance: total - deposit };
  }

  function money(value) { return '$' + value; }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function readValue(control) {
    if (!control) return '';
    if (control.type === 'radio') return control.checked ? (control.value || '') : '';
    if (control.type === 'checkbox') return control.checked ? (control.value || '') : '';
    if (typeof control.value === 'string') return control.value;
    return (control.textContent || '').trim();
  }

  function readTextValue(element) {
    if (!element) return '';
    if (typeof element.value === 'string' && element.value.trim()) return element.value.trim();
    var selected = element.querySelector && element.querySelector('[aria-selected="true"], [data-selected="true"]');
    if (selected && (selected.textContent || '').trim()) return selected.textContent.trim();
    return (element.getAttribute('data-value') || element.textContent || '').trim();
  }

  function findFormsAdapter() {
    var hosts = document.querySelectorAll(FORMS_HOST_SELECTOR);
    var fallback = null;
    for (var i = 0; i < hosts.length; i += 1) {
      var host = hosts[i];
      if (!host.shadowRoot) continue;
      var shadowRoot = host.shadowRoot;
      var adapter = {
        host: host,
        shadowRoot: shadowRoot,
        occasion: shadowRoot.querySelector('[id="custom#occasion-selector-value"], select[name="custom#occasion"], input[name="custom#occasion"]'),
        serviceInputs: shadowRoot.querySelectorAll('input[name="custom#service_type"]'),
        rush: shadowRoot.querySelector('input[name="custom#24-hour_rush"]')
      };
      if (!fallback) fallback = adapter;
      if (adapter.occasion || adapter.serviceInputs.length || adapter.rush) return adapter;
    }
    return fallback;
  }

  function readFormsState() {
    var adapter = findFormsAdapter();
    if (!adapter) return { ready: false, reason: 'host' };

    var selectedService = '';
    for (var i = 0; i < adapter.serviceInputs.length; i += 1) {
      if (adapter.serviceInputs[i].checked) {
        selectedService = adapter.serviceInputs[i].value || '';
        break;
      }
    }

    var ready = Boolean(adapter.occasion && adapter.rush && adapter.serviceInputs.length);
    return {
      ready: ready,
      reason: ready ? '' : 'fields',
      adapter: adapter,
      occasion: readTextValue(adapter.occasion),
      wedding: /wedding/i.test(readTextValue(adapter.occasion)),
      rush: Boolean(adapter.rush && adapter.rush.checked),
      service: selectedService
    };
  }

  function readFallbackState(root, serviceOptions, rush) {
    var occasion = root.querySelector('select[name="contact[occasion]"], input[name="contact[occasion]"]');
    var selected = root.querySelector('[data-tis-service-option] input:checked');
    return {
      ready: true,
      occasion: readValue(occasion),
      wedding: /wedding/i.test(readValue(occasion)),
      rush: Boolean(rush && rush.checked),
      service: selected ? (selected.value || '') : 'Publish-ready'
    };
  }

  function factText(template, amount, estimate) {
    var text = String(template || money(amount));
    text = text.replace(/\$[\d,.]+/, money(amount));
    return estimate && text.indexOf('From ') !== 0 ? 'From ' + text : text;
  }

  function init(root) {
    if (!root || root.__tisCustomRequestInitialized) return;
    root.__tisCustomRequestInitialized = true;

    var formsApp = root.querySelector('[data-tis-forms-app]');
    var appMode = Boolean(formsApp);
    var serviceOptions = root.querySelectorAll('[data-tis-service-option]');
    var rush = root.querySelector('[data-tis-rush-option] input');
    var fallbackOccasion = root.querySelector('select[name="contact[occasion]"], input[name="contact[occasion]"]');
    var total = root.querySelector('[data-tis-total]');
    var deposit = root.querySelector('[data-tis-deposit]');
    var balance = root.querySelector('[data-tis-balance]');
    var summaryTotal = root.querySelector('[data-tis-summary-total]');
    var summaryDeposit = root.querySelector('[data-tis-summary-deposit]');
    var summaryBalance = root.querySelector('[data-tis-summary-balance]');
    var weddingNote = root.querySelector('[data-tis-wedding-surcharge]');
    var estimateNote = root.querySelector('[data-tis-forms-estimate]');
    var nativeService = root.querySelector('[data-tis-native-service]');
    var nativeRush = root.querySelector('[data-tis-native-rush]');
    var totalTemplate = total && (total.getAttribute('data-tis-total-template') || total.textContent);
    var depositTemplate = deposit && (deposit.getAttribute('data-tis-deposit-template') || deposit.textContent);
    var balanceTemplate = balance && (balance.getAttribute('data-tis-balance-template') || balance.textContent);
    var lastSignature = '';
    var retryCount = 0;
    var retryTimer = null;
    var pending = false;
    var observedShadowRoot = null;
    var shadowObserver = null;
    var documentObserver = null;
    var rediscoveryEvents = ['change', 'input', 'click'];

    function stop() {
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = null;
      if (shadowObserver) shadowObserver.disconnect();
      if (documentObserver) documentObserver.disconnect();
      rediscoveryEvents.forEach(function (eventName) { document.removeEventListener(eventName, schedule, true); });
    }

    function render(state) {
      var estimate = appMode && !state.ready;
      var quote = calculateCustomQuote(estimate ? false : state.rush, estimate ? false : state.wedding);
      var wedding = !estimate && state.wedding;
      root.setAttribute('data-tis-wedding', wedding ? 'true' : 'false');
      var choiceNote = root.querySelector('[data-tis-choice-note]');
      if (choiceNote) setText(choiceNote, choiceNote.getAttribute(wedding ? 'data-tis-choice-wedding' : 'data-tis-choice-default'));
      root.querySelectorAll('[data-tis-service-info] b, [data-tis-service-option] b').forEach(function (price) {
        setText(price, money(wedding ? PRICING.weddingTotal : PRICING.baseTotal));
      });
      root.querySelectorAll('[data-tis-step-deposit]').forEach(function (step) {
        setText(step, factText(step.getAttribute('data-tis-step-deposit'), quote.deposit, false));
      });
      root.querySelectorAll('[data-tis-rush-info], [data-tis-rush-option]').forEach(function (option) { option.hidden = wedding; });
      var terms = root.querySelector('[data-tis-request-terms]');
      if (terms) setText(terms, factText(terms.getAttribute('data-tis-request-terms'), quote.deposit, false));
      try { window.sessionStorage.setItem('tis-custom-request-kind', wedding ? 'wedding' : 'other'); } catch (error) { /* Storage is optional; the form remains usable. */ }

      serviceOptions.forEach(function (option) {
        var input = option.querySelector('input');
        option.classList.toggle('is-selected', Boolean(input && input.checked));
      });

      if (estimate) {
        setText(total, factText(totalTemplate, PRICING.baseTotal, true));
        setText(deposit, factText(depositTemplate, PRICING.deposit, false));
        setText(balance, factText(balanceTemplate, PRICING.baseTotal - PRICING.deposit, true));
        setText(summaryTotal, 'From ' + money(PRICING.baseTotal));
        setText(summaryDeposit, money(PRICING.deposit));
        setText(summaryBalance, 'From ' + money(PRICING.baseTotal - PRICING.deposit));
      } else {
        setText(total, factText(totalTemplate, quote.total, false));
        setText(deposit, factText(depositTemplate, quote.deposit, false));
        setText(balance, factText(balanceTemplate, quote.balance, false));
        setText(summaryTotal, money(quote.total));
        setText(summaryDeposit, money(quote.deposit));
        setText(summaryBalance, money(quote.balance));
      }

      if (weddingNote) weddingNote.hidden = estimate || !state.wedding;
      if (estimateNote) {
        estimateNote.hidden = !estimate;
        if (estimateNote.getAttribute('data-tis-forms-estimate-template')) {
          setText(estimateNote, estimateNote.getAttribute('data-tis-forms-estimate-template'));
        }
      }

      if (!appMode) {
        if (nativeService) nativeService.value = state.service || 'Publish-ready';
        if (nativeRush) nativeRush.value = state.rush ? 'Yes' : 'No';
      }
    }

    function apply() {
      var state = appMode ? readFormsState() : readFallbackState(root, serviceOptions, rush);
      var rushControl = appMode ? state.adapter && state.adapter.rush : rush;
      if (state.ready && rushControl) {
        // Click through the app's own handler so its submitted value also clears.
        if (state.wedding && rushControl.checked) rushControl.click();
        if (state.wedding) state.rush = false;
        var rushGroup = appMode ? rushControl.closest('fieldset') : rushControl.closest('[data-tis-rush-option]');
        if (rushGroup) { rushGroup.hidden = state.wedding; if (appMode) rushGroup.disabled = state.wedding; }
      }
      var signature = [state.ready, state.occasion, state.service, state.rush, state.wedding].join('|');
      if (signature !== lastSignature) {
        lastSignature = signature;
        render(state);
      }
      observeShadowRoot(state.adapter && state.adapter.shadowRoot);
      return state;
    }

    function scheduleRetry() {
      if (!appMode || retryTimer || retryCount >= MAX_FORM_RETRIES) return;
      retryTimer = setTimeout(function () {
        retryTimer = null;
        retryCount += 1;
        var state = apply();
        if (!state.ready) scheduleRetry();
      }, FORM_RETRY_DELAY);
    }

    function schedule() {
      if (pending) return;
      pending = true;
      var queue = window.queueMicrotask || function (callback) { setTimeout(callback, 0); };
      queue(function () {
        pending = false;
        var state = apply();
        if (!state.ready) scheduleRetry();
      });
    }

    function observeShadowRoot(shadowRoot) {
      if (!shadowRoot || shadowRoot === observedShadowRoot || !window.MutationObserver) return;
      if (shadowObserver) shadowObserver.disconnect();
      observedShadowRoot = shadowRoot;
      shadowObserver = new MutationObserver(schedule);
      shadowObserver.observe(shadowRoot, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['checked', 'selected', 'aria-selected', 'data-selected', 'data-state', 'value']
      });
      shadowRoot.addEventListener('change', schedule, true);
    }

    serviceOptions.forEach(function (option) { option.addEventListener('change', schedule); });
    if (rush) rush.addEventListener('change', schedule);
    if (fallbackOccasion) {
      fallbackOccasion.addEventListener('input', schedule);
      fallbackOccasion.addEventListener('change', schedule);
    }

    if (appMode && window.MutationObserver) {
      documentObserver = new MutationObserver(schedule);
      documentObserver.observe(document.documentElement || document, { childList: true, subtree: true });
    }

    if (appMode) {
      rediscoveryEvents.forEach(function (eventName) { document.addEventListener(eventName, schedule, true); });
      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined(FORMS_HOST_SELECTOR).then(schedule);
      }
    }

    root.__tisCustomRequestStop = stop;

    var firstState = apply();
    if (!firstState.ready) scheduleRetry();
  }

  function boot() {
    document.querySelectorAll('[data-tis-custom-request]').forEach(init);
    var wedding = false;
    try { wedding = window.sessionStorage.getItem('tis-custom-request-kind') === 'wedding'; } catch (error) { /* Keep the existing success content if storage is unavailable. */ }
    document.querySelectorAll('[data-tis-custom-success]').forEach(function (root) {
      if (!wedding) return;
      var next = root.querySelector('[data-tis-success-next]');
      if (next) setText(next, next.getAttribute('data-tis-wedding-next'));
      var payments = root.querySelector('[data-tis-wedding-payments]');
      if (payments) payments.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.TisCustomPricing = {
    PRICING: PRICING,
    calculateCustomQuote: calculateCustomQuote,
    readFormsState: readFormsState
  };
}());
